import React from "react";

const SectionTitle: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <h3 className="text-center m-0 mb-4 text-gray-700 text-lg underline">
    {children}
  </h3>
);

export default SectionTitle;
